export const filterDataWithValue = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.value === val;
  });
};

export const filterDataWithDesc = (val, DropDownValues) => {
  return DropDownValues.filter(el => {
    return el.desc === val;
  });
};